/**
 * ME STORE
 */

import Vue from "vue";
import api from "Api";
import router from "Router";

const state = {
    person: localStorage.getItem("person"),
    entity_addresses: [],
    entity_phones: [],
    entity_emails: [],
    notifications: [],
};

// getters
const getters = {
    my_notifications: (state) => {
        return state.notifications;
    },
};

// actions
const actions = {
    async fetchMe({ rootState, commit }, payload) {
        try {
            let body = ""; // language: rootState.authStore.currentLocale.locale

            if (payload.body) {
                switch (payload.method) {
                    case "post":
                    case "put":
                    case "patch":
                        body = JSON.stringify(payload.body);
                        break;
                    default:
                        body = payload.body;
                }
            }

            let response;

            switch (payload.method) {
                case "post":
                    response = await api.post(payload.url, body);

                    break;
                case "put":
                    response = await api.put(payload.url, body);

                    break;
                case "patch":
                    response = await api.patch(payload.url, body);

                    break;
                case "delete":
                    response = await api.delete(payload.url, {
                        params: body,
                    });

                    break;
                case "get":
                default:
                    response = await api.get(payload.url, {
                        params: body,
                    });
            }

            if (typeof response !== "undefined") {
                if (response.data && response.data.page) {
                    commit("commitMe", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                let split_state = payload.stateProperty ? (payload.stateProperty || "").split("|") || [] : [];
                let split_data = payload.dataProperty ? (payload.dataProperty || "").split("|") || [] : [];
                split_state.forEach((ss, i) => {
                    let sd = split_data[i] || ss;
                    if (payload.commit) {
                        commit("commitMe", {
                            property: ss,
                            with: _.get(response.data, sd),
                        });
                        if (payload.localStorage) {
                            localStorage.setItem(ss, JSON.stringify(_.get(response.data, sd)));
                        }
                    }
                    if (payload.mutate) {
                        commit("mutateMe", {
                            property: ss,
                            with: _.get(response.data, sd),
                            method: payload.method,
                            id: payload.id,
                            pk: payload.pk,
                        });
                    }
                });

                return response.data;
            } else {
                return;
            }
        } catch (error) {
            throw error;
        }
    },
};

// mutations
const mutations = {
    commitMe(state, payload) {
        _.set(state, payload.property, payload.with || null);
    },
    mutateMe(state, payload) {
        if (payload.method == "post" && payload.with) {
            if (state[payload.property] == null) state[payload.property] = [];
            state[payload.property].push(payload.with);
        } else if (payload.method == "patch" && payload.property && payload.with && payload.pk) {
            let curr_item = state[payload.property][state[payload.property].findIndex((obj) => obj[payload.pk] == payload.with[payload.pk])];
            for (const key in payload.with) if (key in curr_item) curr_item[key] = payload.with[key];
        } else if (payload.method == "delete" && payload.property && payload.pk && payload.id) {
            state[payload.property].splice(
                state[payload.property].findIndex((obj) => obj[payload.pk] == payload.id),
                1
            );
        }
    },
    setNotificationsHandler(state, payload) {
        state.notifications = payload;
    },
    readAllNotifsHandler(state) {
        state.notifications = state.notifications.map((notif) => {
            return { ...notif, read_flag: 1 };
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
